import { useState, useCallback } from "react";

export type ModalType = string;

export interface ModalState {
  [key: string]: boolean;
}

export interface UseModalManagerReturn {
  modalStates: ModalState;
  openModal: (modalType: ModalType) => void;
  closeModal: (modalType: ModalType) => void;
  isOpen: (modalType: ModalType) => boolean;
  toggleModal: (modalType: ModalType) => void;
}

export const useModalManager = (): UseModalManagerReturn => {
  const [modalStates, setModalStates] = useState<ModalState>({});

  const openModal = useCallback((modalType: ModalType) => {
    setModalStates((prev) => ({ ...prev, [modalType]: true }));
  }, []);

  const closeModal = useCallback((modalType: ModalType) => {
    setModalStates((prev) => ({ ...prev, [modalType]: false }));
  }, []);

  const isOpen = useCallback(
    (modalType: ModalType) => {
      return modalStates[modalType] === true;
    },
    [modalStates]
  );

  const toggleModal = useCallback((modalType: ModalType) => {
    setModalStates((prev) => ({ ...prev, [modalType]: !prev[modalType] }));
  }, []);

  return {
    modalStates,
    openModal,
    closeModal,
    isOpen,
    toggleModal,
  };
};
